// extracted by mini-css-extract-plugin
module.exports = {"logo":"FeatureUpsellModal_logo__qFW8k","heading":"FeatureUpsellModal_heading__2HF5G","image":"FeatureUpsellModal_image__5eP_B"};